import { DEBUGGING, GLOBAL_PATH_PREFIX, IS_PRODUCTION } from '../constants';

export default class Logger {

  constructor () {
    throw Error('No instances!');
  }

  /**
   * Info logs only in development
   * @param args
   */
  static info (...args) {
    if (DEBUGGING && console && console.info) {
      console.info(...args);
    }
  }

  /**
   * Warning logs only in development
   * @param args
   */
  static warn (...args) {
    if (DEBUGGING && console && console.warn) {
      console.warn(...args);
    }
  }

  /**
   * Error logs
   *
   * console log in development, post to Rollbar in production
   *
   * @param args
   */
  static error (...args) {
    // if ((DEBUGGING || !IS_PRODUCTION) && console && console.error) {
    //   console.error(...args);
    // }
    //
    // if (!DEBUGGING) {
    //   const rollbar = window.Rollbar;
    //   if (rollbar) {
    //     rollbar.error(...args);
    //   }
    // }

    if (console && console.error) {
      console.error(...args);
    }
  }

  /**
   * Beacon an error out to Rollbar in production, or just info log in development
   *
   * @param args
   */
  static beacon (...args) {
    if (DEBUGGING) {
      Logger.info(...args);
    } else {
      // const rollbar = window.Rollbar;
      // if (rollbar) {
      //   rollbar.info(...args);
      // }
    }
  }

  /**
   * Assert logs
   *
   * post to Rollbar in production and throw an error
   *
   * @param args
   */
  static assert (...args) {
    this.error(...args);

    if (DEBUGGING || !IS_PRODUCTION) {
      throw new Error(...args);
    } else {
      // Redirect away to an error page
      // We do this to stop the execution flow on any code currently running
      // on the page. We do not actually throw an error here because
      // React responds to uncaught exceptions by tearing down the entire page
      // and it's very user unfriendly
      window.location.href = `${GLOBAL_PATH_PREFIX}/error`;
    }
  }

}
